export function DescricaoPagina() {
  return (
    <section className="mt-5">
      <p style={{ marginBottom: 0 }}>
        Veja o andamento das suas solicitações de serviços.
      </p>
    </section>
  );
}
